"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WWReportId = void 0;
var WWReportId;
(function (WWReportId) {
    WWReportId["EndOfModulePerformanceReport"] = "ww-eom-performance-report";
    WWReportId["ParticipationReport"] = "ww-participation-report";
    WWReportId["QuestionSetPerformanceReport"] = "ww-question-set-performance-report";
    WWReportId["FocusingQuestionTaskPerformanceReport"] = "ww-fqt-performance-report";
    WWReportId["NewReadPerformanceReport"] = "ww-nr-performance-report";
    WWReportId["VocPerformanceReport"] = "ww-voc-performance-report";
})(WWReportId || (exports.WWReportId = WWReportId = {}));
//# sourceMappingURL=ww-report-id.enum.js.map